/**
 * 请求地址列表
 * Created by iwaterdata on 2017/3/3.
 */

export const HTMLVERSION = "1.0.4"
// 基本地址
// export const BASEURL = getIpurl(); // 发布
// export const BASEURL = "nige"; // 本地测试
// export const BASEURL1 = "http://proxy.hzguode.com" // 生产环境地址 包头
// export const BASEURL = "http://proxy.hzguode.com/btwt" // 生产环境地址 包头
// export const BASEURLH = "http://1.24.190.190:18199" // 部分接口要用 包头

export const BASEURL = "http://www.ptgps.cn" // 平塘
export const WSTGRT_USER = "/iwater/sso/wstGetuser/login.json"
export const SSOLOGIN = "/btwt/iwater/auth/sso/msb/getToken.json"
// 公用地址(iwaterapi.json)
export const PHONENUM = "/iwatermgr/account/getAccountNoByPhoneNum.json" //根据手机号查询用户信息
// https://zw.linanwater.com:4545/JxReport/ux/jasperjn.action?method=waterListJapserImage
export const JASPERJN = "/JxReport/ux/jasperla.action" //打印水费清单
export const PAYMENTINQUIRY= "/iwater/v1/watermeter/nt/queryMeterInfoByUId/v1.json"//根据户号查询缴费信息
export const UPDATAFORM = '/iwatermgr/transactBusiness/nt/create.json' //提交

export const UPLOADIMAGE = '/img/imgload/upload.json' //oss

export const MONTHMETERNUM = "/iwater/meterpay/getUserMonthMeterNum.json"

export const MONTHM_DATA_ETERNUM = 'iwatermgr/addServers/valuations.json' //根据旧户号获取信息
//营业网点
export const BUSINESSOUT = "/iwater/businessoutPost/businessout.json"

// 获取轮播图
export const GETBANNER = "/iwater/sysAd/getSysAd.json"

//停水公告
export const WATERCUTOFF = "/iwater/waitWaterUser/getwaitWater.json"
//进度查询
export const TODOBUSINESS = '/iwatermgr/transactBusiness/toDoBusiness.json'
//进度查询详情
export const GETFORMINFODATA = '/iwatermgr/transactBusiness/nt/getFormInfodata.json'
export const DEALLBILL = '/iwatermgr/transactBusiness/dealBill.json' //退回表单编辑提交
// 信息公告
export const BBSPOST = "/iwater/bbsPost/BbsPost.json"
// 信息公告点击数
export const UPBBSPOST = "/iwater/bbsPost/upBbsPost.json"
// 停水详情
export const WATERDEATAILS = "/iwater/waitWaterUser/getWaitWaterArea.json"

//获取表单渲染数据
export const GETFORMINFO ="/iwatermgr/transactBusiness/nt/getFormInfo.json"

export const IWATERAPI = "/iwater/iwaterapi.json"
// 获取验证码
export const SENDAUTHCODE = "/iwater/v1/usercenter/nt/sendAuthCode/v1.json"
// 验证验证码
export const JUDGEAUTHCODE = "/iwater/v1/usercenter/nt/judgeAuthCode/v1.json"
// 修改用户信息
export const UPDATEREALINFO = "/iwater/v1/usercenter/updateRealInfo/v1.json"
// 修改昵称
export const UPDATEUSERNICK = "/iwater/v1/usercenter/updateUserNick/v1.json"
// 修改个性签名
export const UPDATESIGNATURE = "/iwater/v1/usercenter/updateSignature/v1.json"
// 修改手机号
export const UPDATEMOBILE = "/iwater/v1/usercenter/updateMobile/v1.json"
// 获取用户收货地址列表
export const QUERYUSERADDRESSLIST = "/iwater/v1/usercenter/queryUserAddressList/v1.json"
// 添加收货地址
export const ADDUSERADDRESS = "/iwater/v1/usercenter/addUserAddress/v1.json"
// 修改收货地址
export const UPDATEUSERADDRESS = "/iwater/v1/usercenter/updateUserAddress/v1.json"
// 修改默认收货地址
export const SETUPDEFAULTADDRESS = "/iwater/v1/usercenter/setupDefaultAddress/v1.json"
// 删除收货地址
export const DELETEADDRESS = "/iwater/v1/usercenter/deleteAddress/v1.json"
// 问题反馈-问题列表
export const QUERYHELPLIST = "/iwater/v1/sys/queryHelpList/v1.json"
// 问题反馈-提问
const ASKFORHELP = "/iwater/v1/sys/askForHelp/v1.json"
// 净水模块-添加设备
export const ADDDEVICE = "/iwater/v1/device/addDevice/v1.json"
// 净水模块-获取充值卡列表
export const RECHARGECARDS = "/iwater/v1/device/rechargeCards/v1.json"
// 净水模块-充值生成订单
export const ADDRECHARGEORDER = "/iwater/v1/device/addRechargeOrder/v1.json"
// 净水模块-充值记录
export const RECHARGERECORDS = "/iwater/v1/device/rechargeRecords/v1.json"
// 净水模块 - 添加设备@代军超
export const GETPURCHASEDEVICES = "/iwater/v1/device/nt/getPurchaseDevices/v1.json"
// 获取我的模块信息
export const GETUSERFUNCTION = "/iwater/v1/watercorp/nt/getUserFunction/v1.json"
//签到
export const SIGN = "/iwater/v1/usercenter/sign/v1.json"
//签到信息
export const SIGNINFO = "/iwater/v1/usercenter/getSignData/v1.json"

//推荐人列表
export const REFEREELIST = "/iwater/v1/preorder/getPartnerList/v1.json"
//资产明细
export const QUERYUSERDRO = "/iwater/v1/usercenter/queryUserDro/v1.json"
// 获取净水器商品列表
export const GETCLEANDEVICELIST = "/iwater/v1/preorder/getDeviceList/v1.json"
// 获取净水器-推荐人资料查询
export const GETENABLEPARTNER = "/iwater/v1/preorder/getEnablePartner/v1.json"

//订单详情
export const DETAILORDER = "/iwater/order/detailOrder/v1.json"
//获取收货地址列表
export const GETADDRESSLIST = "/iwater/v1/usercenter/queryUserAddressList/v1.json"

export const ADDPREORDER = "/iwater/v1/preorder/addPreorder/v1.json"

//获取设备滤芯详情
export const GETFILTERDETAILS = "/iwater/v1/device/filterDetails/v1.json"
//获取水质四项接口
export const WATERQUALITY4ITEMS = "/iwater/v1/waterquality/nt/WaterQuality4Items/v2.json"
//获取水质详情接口
export const GETWATERQUALITY = "/iwater/v1/waterquality/nt/getIndexValueByCity.json"
//分享页提交预定信息
export const ADDSHAREORDER = "/iwater/v1/preorder/nt/addShareOrder/v1.json"
//获取预分享信息
export const GETSHAREINFO = "/iwater/v1/preorder/getShareInfo/v1.json"
// 净水机分享下单
export const ADDSHAREPURCHASEORDER = "/iwater/v1/preorder/nt/addSharePurchaseOrder/v1.json"

//点击点赞
export const CLICKLIKE = "/iwater/v1/iwateressay/clicklike/v1.json"
//点击收藏
export const CLICKCOLLECT = "/iwater/v1/iwateressay/clickcollect/v1.json"
//添加好友
export const ADDFRIEND = "/iwater/v1/usercenter/addFriend/v1.json"
//首页-获取模块信息
export const GETMODULEDATA = "/iwater/v1/appFunction/getModuleData.json"
//获取天气信息
export const GETWEATHERDATA = "/iwater/v1/waterquality/nt/getWeatherCond/v2.json"
//获取可能的好友
export const GETADDRESSBOOK = "/iwater/v1/userAddressBook/getAddressBook.json"

//获取优惠券列表
export const GETMYCOUPON = "/iwater/v1/shop/getMyCoupon/v2.json"
//核销券
export const CHARGEOFFCOUPON = "/iwater/v1/shopcoupon/chargeOffCoupon/v1.json"
//获取可用优惠券
export const GETSHOPAVAILABLECOUPONS = "/iwater/v1/shop/getShopAvailablecoupons/v1.json"
//获取商户代金券详情
export const GETOPSTORECOUPONINFO = "/iwater/opstorecoupon/getOpStoreCouponInfo.json"


//获取水价信息
export const GETPRICELIST = "/iwater/watercorpprice/nt/getPriceList.json"
//根据用户id获取水表列表接口
export const GETMETERLIST = "/iwater/v1/watermeter/queryUserMeterList/v1.json"

export const QUERYWETRE2 = '/iwater/v1/watermeter/searchMeterInfoByUId/v1.json'

//根据用户id获取微信公众号水表列表接口
export const GETWXMETERLIST = "/iwater/v1/watermeter/queryWxUserMeterList/v1.json"
//获取服务地区列表及相应服务
export const GETWATERCORPINFO = "/iwater/v1/server/nt/getWaterCorpInfo/v2.json"
//查询水司列表
export const WATERCORPLIST = "/iwater/v1/watercorp/nt/watercorpList.json"
//查询水表信息
export const GETMETERINFOBYUID = "/iwater/v1/watermeter/getMeterInfoByUId/v1.json"
//根据水司预留手机号获取水表信息
export const GETMETERLISTBYMOBILE = "/iwater/v1/watermeter/getMeterListByMobile/v1.json"
//添加水表
export const ADDMETER = "/iwater/v1/watermeter/addMeter/v1.json"
//缴费页历史折线图
export const GETMETERPAYMENT = "/iwater/v1/watermeter/queryPayMentInfo/v2.json"
// 获取缴费记录（只有通过 网厅或者app 的缴费、预存记录）
export const GETPAYMENTHISTORY = "/iwater/memeterinfo/getHangShuiRecord.json"
//删除水表
export const DELMETER = "/iwater/v1/watermeter/deleteMeter/v1.json";
//修改水表昵称
export const UPDMETER = "/iwater/v1/watermeter/setMeterNick.json";
//设置账单提醒
export const SETMETERALERT = "/iwater/v1/watermeter/setMeterAlert/v1.json";
//设置自动缴费
export const SETMETERAUTPAYMENT = "/iwater/v1/watermeter/setMeterAutPayment.json";
//通过水表id查询应缴费信息
export const QUERYPAYINFO = "/iwater/v1/watermeter/queryPayInfo/v2.json";
//水币支付
export const WATERPAY = "/iwater/v1/shop/waterPay/v1.json"
//钱包支付
export const ZEROPAYSHOP = "/iwater/v1/shop/zeroPayShop.json"
//获取支付信息
export const GETPAYREQUESTINFO = "/iwater/v1/pay/nt/getPayRequestInfo/v3.json"
//获取支付成功信息（缴水费）
export const PAYSUCCESSINFO = "/iwater/v1/pay/paySuccessInfo.json"
// 获取用户缴费历史记录(所有的水费账单记录)
export const QUERYPAYMENTINFO = '/iwater/v1/watermeter/queryPayMentInfo/v2.json'
//钱包充值下单
export const WALLETRECHARGEORDER = "/iwater/v1/usercenter/createWalletRechargeOrder/v1.json"
//余额明细
export const QUERYWALLETDETAILS = "/iwater/v1/usercenter/queryWalletDetails/v1.json"
//商户下单接口
export const ADDSTOREORDER = "/iwater/v1/storeOrder/addStoreOrder/v1.json"
// 虚拟币支付接口
export const DUMMYPAYMENTS = "/iwater/v1/shop/dummyPayments/v1.json"
// 杭水 缴费下单
export const MAKEWATERFEEORDER = "/iwater/v1/watermeter/makeWaterFeeOrder/v2.json"
// 杭水 获取支付状态
export const CHECKORDERSTATUS = "/iwater/v1/shop/checkOrderStatus/v2.json"

// 杭水 根据户名 地址查询户号
// export const GETMETERNOLIST = "/iwater/memeterinfo/getMeterNoList.json"
export const GETMETERNOLIST = "/iwater/v1/watermeter/getMeterInfoByUId/v1.json"
//杭水根据工程编号查询工程费用
export const GETPROJINFO = "/iwater/v1/watermeter/queryBillPayInfo.json"

//微信jsjdk初始化参数
export const GETWXAUTH = "/iwater/seasongame/nt/getWxauth.json"

/**
 * 红包相关接口
 */
//用户获取本期红包活动详情
export const GETREDMONEYDETAILS = "/iwater/v1/redmoney/getRedmoneyDetails/v1.json"
//获取好友本期红包活动详情
export const GETFRIENDREDMONEYDETAILS = "/iwater/v1/redmoney/getFriendRedmoneyDetails/v1.json"
//获取用户与好友在往期偷红包活动的比拼列表
export const GETUSERFRIENDCOMPETITIONS = "/iwater/v1/redmoney/getUserFriendCompetitions/v1.json"
//用户获取往期红包活动详情
export const GETPREVIOUSREDMONEYDETAILS = "/iwater/v1/redmoney/getPreviousRedmoneyDetails/v1.json"
//获取用户往期红包活动历史列表
export const GETREDMONEYHISTORY = "/iwater/v1/redmoney/getRedmoneyHistory/v1.json"
//用户拆红包
export const UNPACKREDMONEY = "/iwater/v1/redmoney/unpackRedmoney/v1.json"
//获取红包奖金排行榜
export const GETAMOUNTLIST = "/iwater/v1/redmoney/getAmountList/v1.json"
//获取好友红包奖金排行榜
export const GETFRIENDAMOUNTLIST = "/iwater/v1/redmoney/getFriendAmountList/v1.json"
//获取用户红包被偷记录
export const GETREDMONEYBESTOLENEVENTS = "/iwater/v1/redmoney/getRedmoneyBeStolenEvents/v1.json"
//用户偷红包
export const STEALREDMONEY = "/iwater/v1/redmoney/stealRedmoney/v1.json"
//用户抢爱水红包
export const GRABREDMONEY = "/iwater/v1/redmoney/grabRedmoney/v1.json"
//道具商城接口
export const GETONSALEPROPS = "/iwater/v1/props/getOnSaleProps/v1.json"
//背包接口
export const GETGAMEPOKEY = "/iwater/v1/props/getGamepokey/v1.json"
//扫码和红包分享注册接口
export const ACTIVITEREGISTER = "/iwater/v1/user/nt/activiteRegister/v2.json"
//根据道具类型获取用户下道具列表接口
export const GETPROPSBYTYPE = "/iwater/v1/props/getPropsByType/v1.json"
//提现记录页数据
export const REDMONEYWITHDRAWAL = "/iwater/v1/redmoneyWithdrawal/redmoneyWithdrawalPageData/v1.json"
//提现
export const MMPAYMKTTRANSFERS = "/iwater/v1/pay/mmpaymkttransfers/v1.json"
//使用道具接口
export const USEPROPS = "/iwater/v1/props/useProps/v1.json"


/**
 * 获取用户会员中心详情
 */
//使用道具接口
export const GETMEMBERCENTERDETAILS = "/iwater/v1/member/getMemberCenterDetails/v1.json"
//获取用户特权详情
export const GETPRIVILEGEDETAILS = "/iwater/v1/member/getPrivilegeDetails/v1.json"
//获取会员攻略详情
export const GETMEMBERSTRATEGYDETAILS = "/iwater/v1/member/getMemberStrategyDetails/v1.json"
//获取会员成长值列表
export const GETMEMBERGROWTHS = "/iwater/v1/member/getMemberGrowths/v1.json"

// 查询业务办理进度 / 客服服务工单进度
export const QUERYPROGR = '/iwatermgr/transactBusiness/toDoBusiness.json'
// 获取全部业务
export const GETALLBUSINESS =  '/iwatermgr/html/systemModule/file/ModuleData_APP_3.json'
// 保存选择的业务
export const CHOOSEFUN = '/iwater/v1/appFunction/chooseFun.json'
// 开票
export const DRAWBILL = '/iwatermgr/bill/invoiceDz.json'
// 短信定制
export const SMSCUSTOMIZATION = '/iwatermgr/userper/nt/SMSCustomization.json'
//水费发还列表
export const WATERFEEDREFUNDLIST = '/iwatermgr/bill/getReturnFeeList.json'
//热线 文件上传
export const HSUPLOAD = BASEURL + '/iwatermgr/attach/nt/HsUpload.json'
// 获取 需求文件列表 水费发还
export const GETFILETYPE = '/iwatermgr/transactBusiness/nt/getFileType.json'
//水费发还申请
export const RETURNFEE = '/iwatermgr/bill/returnFee.json'
//获取水费发还原因
export const GETRETURNFEEDREASON = '/iwatermgr/transactBusiness/nt/getspecialReasonList.json'
//获取证件类型
export const GETDATADICTIONARY = '/iwatermgr/transactBusiness/nt/getDataDictionary.json'
//用水人口变更提交
export const REGISTERPOPULATION = '/iwatermgr/transactBusiness/nt/peopleChangeSubmit.json'

//用水人口变更修改提交
export const PEOPLECHANGEEDITSUBMIT = '/iwatermgr/transactBusiness/nt/peopleChangeDealBill.json'

//微信端用户进入页面时候绑定
export const MOBILEBINDNO = '/iwater/v1/usercenter/bindMobile/v1.json'
//微信端用户进入页面时候先判断是否绑定
export const MOBILEBINDCHECK = '/iwater/v1/usercenter/checkMobile/v1.json'
//杭水 工程编号绑定
export const BINDWORKNO = BASEURL + '/iwatermgr/transactBusiness/biandBill.json'

// 实时水量
export const WATERCOLUMN = BASEURL + '/hangzhou/jc/getBigMeterInstant.json'
// 实时日期水量
export const WATEREWEEK = BASEURL + '/hangzhou/jc/getSevenMeterWater.json'
// 个人签章
export const ELECTRON = BASEURL + '/iwater/electron/nt.json'
// 个人签章
export const ELECTRONuUSER = BASEURL + '/iwater/electron/user.json'
// 企业认证
export const AUTNENTICATION = BASEURL + '/iwater/electron/authentication.json'
// 企业认证结果查询
export const AUTNENTICATIONQUERY = BASEURL + '/iwater/electron/query.json'
// 企业认证结果查询
export const UITQUERY = BASEURL + '/iwater/electron/uit/query.json'

export const CHAOB = '/iwatermgr/transactBusiness/getMeterRederInfo.json';

//问卷调查开始
export const START_OF_QUESTIONNAIRE_SURVEY = "iwater/psqTitle/findYesRelease.json"
//问卷调查查询
export const START_OF_QUESTIONNAIRE_PSQTITLE_SURVEY = "iwater/psqTitle/findPsqTitleMiniApp.json"
//问卷调查提交
export const START_OF_QUESTIONNAIRE_PSQTDATAILET_SURVEY = "iwater/psqTitle/submitPsqTitleMiniApp.json"



